import React from 'react';
import ReactDOM from 'react-dom/client';
import MainApplication from './app/main';
import i18n from "i18next";
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';


i18n
  .use(initReactI18next)
  .init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
  },
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
})
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <MainApplication />
  </React.StrictMode>
);
